/** The comments section of the node inspector (its title and fold are `NodePanel`'s). */
import { For, Show, type JSX } from "solid-js";
import type { Node } from "@protocol/Node";
import { useApp } from "../../app/context";
import { toast } from "../../shared/toast";
import { formatDate } from "../../shared/ui";

/** The comments on a node, and a form to add one. */
export function NodeComments(props: { node: () => Node }): JSX.Element {
  const n = props.node;
  const { actions } = useApp();
  let comment!: HTMLTextAreaElement;
  return (
    <>
      <div class="node-comments">
        <Show when={n().comments.length}>
          <ul class="cmts">
            <For each={n().comments}>
              {(c, i) => (
                <li>
                  <div class="cbody">{c.text}</div>
                  <div class="cmeta">
                    <span>{formatDate(c.at)}</span>
                    <button type="button" class="x" aria-label="Delete comment" title="Delete comment" onClick={() => void actions.removeComment(n().id, i())}>
                      ×
                    </button>
                  </div>
                </li>
              )}
            </For>
          </ul>
        </Show>
        <div class="cform">
          <label class="sr" for="comment">
            Comment
          </label>
          <textarea class="field" id="comment" ref={comment} rows="3" maxlength="500" placeholder={`Write a comment about ${n().name}`} />
          <button
            type="button"
            class="btn"
            id="add-comment"
            onClick={() => {
              const text = comment.value.trim();
              if (!text) return toast("Write a comment first.");
              void actions.addComment(n().id, text).then((ok) => {
                if (!ok) return;
                comment.value = "";
                toast("Comment added.");
              });
            }}
          >
            Add comment
          </button>
        </div>
      </div>
    </>
  );
}
